import React from 'react';
import { IconButton, Button } from '@mui/material';
import styled from 'styled-components';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

type CollapseCellProps = {
  isExpanded: boolean;
  onCollapse: () => void;
  CustomComponent?: any;
  useDefaultTextCollapseButton?: boolean;
  disabled?: boolean;
};

const DefaultTextCollapseButton = ({
  onClick,
  disabled,
  isExpanded,
}: {
  onClick: any;
  isExpanded: boolean;
  disabled?: boolean;
}) => {
  return (
    <ExpandCollapseButton disabled={disabled} color="primary" onClick={onClick}>
      {isExpanded ? 'Collapse' : 'Expand'}
    </ExpandCollapseButton>
  );
};

const ExpandCollapseButton = styled(Button)`
  position: relative;
  bottom: 60px;
`;

const CollapseCell = ({
  isExpanded,
  onCollapse,
  CustomComponent,
  useDefaultTextCollapseButton,
  disabled = false,
}: CollapseCellProps) => {
  if (CustomComponent) return <CustomComponent isExpanded={isExpanded} onClick={onCollapse} />;

  if (useDefaultTextCollapseButton)
    return (
      <DefaultTextCollapseButton isExpanded={isExpanded} onClick={onCollapse} disabled={disabled} />
    );

  return (
    <IconButton size="small" onClick={onCollapse}>
      {' '}
      {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
    </IconButton>
  );
};

export default CollapseCell;
